import React, { Component } from "react"
import styled from "styled-components"

import { inject, observer } from "mobx-react"
import Spacer from "~/components/Spacer"

import OrderCard from "./Order"
import RobotOrderCard from "./RobotOrder"

import SignUpForm from "~/components/auth/SignUpForm"
import PaymentInfo from "./Form"
import CheckoutAbandonTracker from "~/components/tracking/CheckoutAbandonTracker"
import Card, { CardSection } from "~/components/parking/_design/Card"

const PageContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  padding: 0 2em 0 2em;
  margin: 0 auto;
  background-color: ${(props) => props.theme.colors.background.main};
  ${(props) => props.theme.media.smallDesktop`
  flex-direction: column;
  justify-content: flex-start;
  `}
  ${(props) => props.theme.media.mobile`
  padding: 0 1em 0 1em;
  `}
`

const LeftContainer = styled.div`
  ${(props) => props.theme.media.smallDesktop`
    display: flex;
    flex-direction: column-reverse
    align-items: center;
    justify-content: center;
  `}
`

const RightContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 750px;
  ${(props) => props.theme.media.smallDesktop`
    align-items: center;
    justify-content: center;
    padding-top: 16px;
  `}
`

const CardWrap = styled.div`
  // Align the top-most right-column card with the price-breakdown card,
  // which sits under a 30px desktop Spacer on the left column. Applied to
  // whichever card renders first: Contact when logged-out, Payment when the
  // user is logged in and the Contact card is hidden.
  ${(props) => (props.top ? "margin-top: 30px;" : "")}
  // Full width so the card stretches to the column even though RightContainer
  // centers its children (align-items: center) on small screens — without this
  // the card shrinks to its content width and no longer spans the column.
  width: 100%;
  ${(props) => props.theme.media.smallDesktop`
    margin-top: 0;
  `}
`

const SpacerContainer = styled.div`
  ${(props) => props.theme.media.smallDesktop`
    display:none;
  `}
`
@inject((all) => ({
  isPayFlow: all.store.parkingFlow.flow.isPayFlow,
  isRobotPayFlow: all.store.parkingFlow.flow.isRobotPayFlow,
  isLoggedIn: all.store.auth.isLoggedIn,
  isPayNYCFlow: all.store.ui.isPayNYCFlow,
}))
@observer
class ParkingCheckout extends Component {
  render() {
    const { isPayFlow, isRobotPayFlow, isLoggedIn, isPayNYCFlow } = this.props
    return (
      <PageContainer>
        {isPayNYCFlow && isPayFlow && <CheckoutAbandonTracker />}
        <LeftContainer>
          <SpacerContainer>
            <Spacer desktop={30} />
          </SpacerContainer>
          {isPayFlow && <OrderCard />}
          {!isPayFlow && isRobotPayFlow && <RobotOrderCard />}
        </LeftContainer>
        <Spacer direction="width" desktop={60} mobile={10} />
        <RightContainer>
          {!isLoggedIn && (
            <CardWrap top>
              <Card title="Contact Information">
                <CardSection>
                  <SignUpForm accountRequired={false} notched cardless />
                </CardSection>
              </Card>
            </CardWrap>
          )}
          <CardWrap top={isLoggedIn}>
            <Card title="Payment">
              <CardSection>
                <PaymentInfo cardless />
              </CardSection>
            </Card>
          </CardWrap>
        </RightContainer>
      </PageContainer>
    )
  }
}

export default ParkingCheckout
